import wpApi from '@/utils/functions/wordpress/wpApi';

const fetchAttachment = async (name: string): Promise<any[]> => {
    const api = wpApi();
    const file = await api.media().search(name).embed().get();

    return file;
};

export default fetchAttachment;
